import { makeRequest } from 'utils/requestLogger';

export default ({ discussion_id, question, answers, status }) => {
  return makeRequest('post', `/api/polls`, {
    live_discussion_id: discussion_id,
    question,
    answers,
    status,
  });
};



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/createPoll.js